import React from 'react'
import type { MeResponse } from '../api/me'

const MeContext = React.createContext<MeResponse | null>(null)

export const MeProvider: React.FC<{ value: MeResponse; children: React.ReactNode }> = ({ value, children }) => (
  <MeContext.Provider value={value}>{children}</MeContext.Provider>
)

export const useMe = (): MeResponse => {
  const context = React.useContext(MeContext)

  if (!context) {
    throw new Error('useMe must be used within a MeProvider')
  }

  return context
}

export default MeContext
